module.exports = __webpack_public_path__ + "img/05.774a8c85.png";